<template>
  <span class="application-rating" :style="cssColors" >
    <span>
      <template v-for="star in [0.5, 1.0, 1.5, 2.0, 2.5, 3.0, 3.5, 4.0, 4.5, 5.0]">
        <span :key="star" class="hover-off" :class="{'star--half' : star % 1 != 0}">
          <v-icon
            :color="rating / 2 >= star ? 'primary' : 'grey lighten-3'"
          >
          mdi-star
          </v-icon>
        </span>
      </template>
    </span>
  </span>
</template>

<script>
import colors from '@/data/colors'

export default {
  props: { application: Object },
  data() {
    return {
      rating: this.application.applicationRating,
      colors
    }
  },
  computed: {
    cssColors() {
      return {
        '--star-color': this.colors.deepOrange.base,
        '--star-color-active': this.LightenDarkenColor(this.colors.deepOrange.base, 50),
        '--star-color-inactive': this.colors.grey.lighten3
      }
    },

    stars() {
      return parseInt(this.value / 2)
    }
  },
  methods: {
    LightenDarkenColor(col, amt) {
      var usePound = false

      if (col[0] == '#') {
        col = col.slice(1)
        usePound = true
      }

      var num = parseInt(col, 16)

      var r = (num >> 16) + amt

      if (r > 255) r = 255
      else if (r < 0) r = 0

      var b = ((num >> 8) & 0x00ff) + amt

      if (b > 255) b = 255
      else if (b < 0) b = 0

      var g = (num & 0x0000ff) + amt

      if (g > 255) g = 255
      else if (g < 0) g = 0

      return (usePound ? '#' : '') + (g | (b << 8) | (r << 16)).toString(16)
    }
  }
}
</script>

<style lang="scss">
span.application-rating fieldset {
  position: absolute;
  display: inline-block;
  padding: 0;
  border: none;
}

span.application-rating input {
  display: none;
}

span.application-rating label {
  float: right;
  font-size: 0;
}

span.application-rating label > i:before {
  content: '\F4CE';
  font-size: 24px;
  color: var(--star-color-inactive);
}

span.application-rating label:hover ~ label > i:before,
span.application-rating label:hover > i:before,
span.application-rating {
  content: '\F4CE';
  color: var(--star-color-active);
  transition: 0.2s;
}

span.application-rating input:checked ~ label > i:before {
  content: '\F4CE';
  color: var(--star-color);
}

span.application-rating input:checked ~ label:hover > i:before,
span.application-rating input:checked ~ label:hover ~ label > i:before {
  color: var(--star-color-active);
  transition: 0.2s;
}

/* Half-star*/
span.application-rating .star--half {
  position: relative;
}

span.application-rating .star--half > i {
  position: absolute;
  padding-right: 0;
  -webkit-clip-path: polygon(0 0, 50% 0, 50% 100%, 0% 100%);
  clip-path: polygon(0 0, 50% 0, 50% 100%, 0% 100%);
}

span.application-rating .star--half:hover > i:before {
  content: '\F4CE';
}

span.application-rating span.readonly-rating .hover-off > i:before {
  content: "";
}
</style>
